import React from 'react';
import Gallery from 'react-grid-gallery'
import './photos_carousel.css';

class PhotosCarousel extends React.Component {

    constructor(props){
        super(props);

        const { photos } = props;
        const images = [];
        if(photos){
            if(photos.length){
                photos.forEach( (image) => {
                    images.push({
                        src: image.url,
                        thumbnail: image.url,
                        thumbnailWidth: 320,
                        thumbnailHeight: 320,
                        isSelected: false,
                        caption: image.name
                    });
                });
            }
        }
        this.state = {
            images: images
        }
    }

    onSelectImage (index) {
        var images = this.state.images.slice();
        var img = images[index];
        if(img.hasOwnProperty("isSelected"))
            img.isSelected = !img.isSelected;
        else
            img.isSelected = true;

        this.setState({
            images: images
        });
    }

    render() {
        const {images} = this.state;
        if(images){
            if(images !== null && images.length > 0){
                return (
                    <div className="carousel-container row justify-content-center">
                        <div className="col-md-10">
                            <Gallery
                                images={images}
                                onSelectImage={this.onSelectImage}
                                lightboxWidth={750}
                                enableImageSelection={false}
                            />
                        </div>
                    </div>
                );
            }
        }

        return (<p>No se encontraron imagenes</p>);
    }
}

export default PhotosCarousel;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/Carousel/PhotosCarousel.js